import { createContext } from 'react';

type Tcontext = {
  activeTab: string,
  setTab: Function,
}

export const TabBarContext = createContext<Tcontext>({
  activeTab: '',
  setTab: () => { },
});
